var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBxFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6379 7.65508C16.5971 7.56675 16.5462 7.48258 16.4746 7.41091L11.4746 2.41091C11.4029 2.33925 11.3187 2.28841 11.2304 2.24758C11.2054 2.23591 11.1787 2.22925 11.1521 2.22008C11.0821 2.19675 11.0104 2.18175 10.9362 2.17758C10.9187 2.17591 10.9029 2.16675 10.8854 2.16675H5.05207C4.13291 2.16675 3.38541 2.91425 3.38541 3.83341V17.1667C3.38541 18.0859 4.13291 18.8334 5.05207 18.8334H15.0521C15.9712 18.8334 16.7187 18.0859 16.7187 17.1667V8.00008C16.7187 7.98258 16.7096 7.96675 16.7079 7.94841C16.7037 7.87425 16.6896 7.80258 16.6654 7.73258C16.6571 7.70591 16.6496 7.68008 16.6379 7.65508ZM13.8737 7.16672H11.7187V5.01172L13.8737 7.16672ZM5.05207 17.1668V3.83344H10.0521V8.0001C10.0521 8.46093 10.4246 8.83344 10.8854 8.83344H15.0521L15.0537 17.1668H5.05207Z",
    fill: "#A6B0CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.71872 10.5001H13.3854V12.1667H6.71872V10.5001ZM6.71872 13.8334H13.3854V15.5001H6.71872V13.8334ZM6.71872 7.16675H8.38539V8.83341H6.71872V7.16675Z",
    fill: "#A6B0CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxFile);
export default __webpack_public_path__ + "static/media/bx-file.bc5e1d05.svg";
export { ForwardRef as ReactComponent };